import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["src", "width", "height"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.showImage)
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        (_ctx.backgroundImage)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(_ctx.classes),
              style: _normalizeStyle({ backgroundImage: 'url(' + _ctx.src + ')' })
            }, [
              _renderSlot(_ctx.$slots, "default")
            ], 6))
          : (_openBlock(), _createElementBlock("img", {
              key: 1,
              src: _ctx.src,
              width: _ctx.width,
              height: _ctx.height,
              class: _normalizeClass(_ctx.classes)
            }, null, 10, _hoisted_1))
      ], 64))
    : _createCommentVNode("", true)
}